/* Native dialog + native Shopify newsletter. No external SDK, tracking or email storage. */
(() => {
  'use strict';
  if (window.FabrikoneProjectPopup) { window.FabrikoneProjectPopup.init(); return; }
  const instances = new Map();
  const styles = new Map();
  const dismissKey = 'fab-project-popup-dismiss-v1';
  const pendingKey = 'fab-project-popup-pending-v1';
  const formHash = '#FabProjectSignup-';
  const editor = Boolean(window.Shopify && window.Shopify.designMode);
  function read(area, key) { try { return Number(window[area].getItem(key)) || 0; } catch (_) { return 0; } }
  function write(area, key, value) { try { window[area].setItem(key, String(value)); } catch (_) {} }
  function visible(el) {
    if (!el || el.hidden || el.getAttribute('aria-hidden') === 'true') return false;
    const style = getComputedStyle(el);
    return style.display !== 'none' && style.visibility !== 'hidden' && el.getClientRects().length > 0;
  }
  function loadStyle(url) {
    if (styles.has(url)) return styles.get(url);
    const promise = new Promise((resolve, reject) => {
      const link = document.createElement('link');
      link.rel = 'stylesheet'; link.href = url; link.dataset.fabPopupStyle = 'true';
      link.onload = resolve;
      link.onerror = () => { link.remove(); styles.delete(url); reject(new Error('Popup stylesheet unavailable')); };
      document.head.appendChild(link);
    });
    styles.set(url, promise); return promise;
  }
  class Finder {
    constructor(el) {
      this.el = el; this.ready = false; this.opening = false; this.shown = false;
      this.controller = new AbortController();
      this.options = { signal: this.controller.signal };
      this.form = el.querySelector('form');
      this.persistClose = true;
      el.querySelector('[data-fab-close]').addEventListener('click', () => this.close(), this.options);
      el.addEventListener('cancel', e => { e.preventDefault(); this.close(); }, this.options);
      el.addEventListener('keydown', e => {
        if (e.key !== 'Tab') return;
        const stops = [...el.querySelectorAll('a[href],button:not([disabled]),input:not([type=hidden]):not([disabled]),select:not([disabled]),[tabindex="0"]')].filter(visible);
        const first = stops[0], last = stops[stops.length - 1];
        if (!first) return;
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }, this.options);
      el.addEventListener('click', e => {
        if (e.target !== el) return;
        const rect = el.getBoundingClientRect();
        if (e.clientX < rect.left || e.clientX > rect.right || e.clientY < rect.top || e.clientY > rect.bottom) this.close();
      }, this.options);
      el.addEventListener('close', () => {
        document.documentElement.classList.remove('fab-finder-open');
        if (this.persistClose && !editor) this.dismiss();
        this.persistClose = true;
        if (this.previous && this.previous.isConnected) this.previous.focus({ preventScroll: true });
      }, this.options);
      el.querySelectorAll('[data-fab-project-link]').forEach(link => {
        link.addEventListener('click', () => { if (!editor) this.dismiss(); }, this.options);
      });
      if (this.form) this.form.addEventListener('submit', e => {
        if (!this.form.checkValidity()) { e.preventDefault(); this.form.reportValidity(); return; }
        // Store no email address. Shopify handles submission, spam challenge and consent.
        write('sessionStorage', pendingKey, Date.now());
      }, this.options);
      const resume = () => { if (this.ready && !this.shown) this.attempt(); };
      document.addEventListener('visibilitychange', resume, this.options);
      document.addEventListener('focusout', () => setTimeout(resume, 200), this.options);
      document.addEventListener('pointerup', () => setTimeout(resume, 350), this.options);
      document.addEventListener('visitorConsentCollected', () => setTimeout(resume, 350), this.options);
      window.addEventListener('hashchange', () => this.checkRequest(), this.options);
      const result = el.querySelector('[data-fab-result]');
      const pending = read('sessionStorage', pendingKey);
      const ownReturn = location.hash.startsWith(formHash) || (pending > 0 && Date.now() - pending < 600000);
      if (result && ownReturn) {
        write('sessionStorage', pendingKey, 0);
        if (result.dataset.fabResult === 'success' && !editor) this.dismiss();
        this.show(true); return;
      }
      if (this.checkRequest()) return;
      if (editor || el.dataset.subscribed === 'true' || this.suppressed()) return;
      const schedule = () => { this.timer = setTimeout(() => { this.ready = true; this.attempt(); }, Math.max(1000, Number(el.dataset.delay) || 25000)); };
      if (document.readyState === 'complete') schedule();
      else window.addEventListener('load', schedule, { once: true, signal: this.controller.signal });
    }
    suppressed() { return read('localStorage', dismissKey) > Date.now() || read('sessionStorage', dismissKey) > Date.now(); }
    dismiss() {
      const until = Date.now() + (Number(this.el.dataset.repeatDays) || 7) * 86400000;
      write('localStorage', dismissKey, until); write('sessionStorage', dismissKey, until);
    }
    blocked() {
      if (document.hidden) return true;
      const active = document.activeElement;
      if (active && active.matches('input,textarea,select,[contenteditable="true"]')) return true;
      if (document.documentElement.hasAttribute('scroll-lock') || document.body.classList.contains('overflow-hidden')) return true;
      return [...document.querySelectorAll('dialog[open],[role="dialog"][aria-modal="true"],side-drawer[open],.shopify-pc__banner,#shopify-pc__banner,[data-consent-banner]')].some(node => node !== this.el && visible(node));
    }
    attempt() { if (!this.suppressed() && !this.blocked()) this.show(false); }
    checkRequest() {
      if (location.hash === '#fabrikone-projeni-bul') { this.show(true); return true; }
      return false;
    }
    async show(manual) {
      if (this.el.open || this.opening || typeof this.el.showModal !== 'function') return;
      if (!manual && (this.shown || this.suppressed() || this.blocked())) return;
      this.opening = true;
      try {
        await loadStyle(this.el.dataset.css);
        if (!this.el.isConnected || (!manual && this.blocked())) return;
        this.el.querySelectorAll('img[data-fab-src]').forEach(img => { img.src = img.dataset.fabSrc; delete img.dataset.fabSrc; });
        this.previous = document.activeElement;
        this.el.hidden = false;
        this.el.showModal();
        document.documentElement.classList.add('fab-finder-open');
        this.shown = true;
        const target = this.el.querySelector('[data-fab-result]') || this.el.querySelector('[data-fab-close]');
        target.focus({ preventScroll: true });
      } catch (_) {
        this.el.hidden = true; // Never expose an unstyled or inaccessible overlay.
      } finally { this.opening = false; }
    }
    close(persist = true) { this.persistClose = persist; if (this.el.open) this.el.close(); }
    destroy() {
      clearTimeout(this.timer); this.close(false); this.controller.abort();
      document.documentElement.classList.remove('fab-finder-open');
    }
  }
  function init(scope = document) {
    scope.querySelectorAll('[data-fab-project-popup]').forEach(el => {
      if (!instances.has(el)) instances.set(el, new Finder(el));
    });
  }
  document.addEventListener('shopify:section:load', e => init(e.target));
  document.addEventListener('shopify:section:unload', e => {
    instances.forEach((instance, el) => { if (e.target.contains(el)) { instance.destroy(); instances.delete(el); } });
  });
  document.addEventListener('shopify:section:select', e => {
    instances.forEach((instance, el) => { if (el.dataset.sectionId === e.detail.sectionId) instance.show(true); });
  });
  document.addEventListener('shopify:section:deselect', e => {
    instances.forEach((instance, el) => { if (el.dataset.sectionId === e.detail.sectionId) instance.close(false); });
  });
  window.FabrikoneProjectPopup = { init };
  init();
})();
